import { lazy } from 'react';
import { FINANCE_PERMISSIONS } from './constants';

const InvoiceListPage = lazy(() => import('./pages/InvoiceListPage'));
const InvoiceDetailPage = lazy(() => import('./pages/InvoiceDetailPage'));
const PaymentListPage = lazy(() => import('./pages/PaymentListPage'));
const PaymentDetailPage = lazy(() => import('./pages/PaymentDetailPage'));
const InstallmentListPage = lazy(() => import('./pages/InstallmentListPage'));

export const financeRoutes = [
  {
    path: '/invoices',
    element: InvoiceListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.invoices', icon: 'FileDoneOutlined', group: 'finance' },
  },
  { path: '/invoices/:id', element: InvoiceDetailPage, permission: FINANCE_PERMISSIONS.READ, nav: null },
  {
    path: '/payments',
    element: PaymentListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.payments', icon: 'DollarOutlined', group: 'finance' },
  },
  { path: '/payments/:id', element: PaymentDetailPage, permission: FINANCE_PERMISSIONS.READ, nav: null },
  {
    path: '/installments',
    element: InstallmentListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.installments', icon: 'CalendarOutlined', group: 'finance' },
  },
];
